export const SCREENSHOT_GUARD_ACTIVE_CLASS = 'beedoo-screenshot-guard-active';
const SCREENSHOT_ALLOWED_VALUES = [true, 1, '1', 'true'];

export function isScreenshotAllowedFlag(value) {
  return SCREENSHOT_ALLOWED_VALUES.includes(value);
}

let isInitialized = false;

export function initScreenshotGuard() {
  if (typeof window === 'undefined' || typeof document === 'undefined' || isInitialized) {
    return;
  }

  isInitialized = true;
  document.documentElement.classList.add(SCREENSHOT_GUARD_ACTIVE_CLASS);
}

export function destroyScreenshotGuard() {
  if (typeof document !== 'undefined') {
    document.documentElement.classList.remove(SCREENSHOT_GUARD_ACTIVE_CLASS);
  }
  isInitialized = false;
}

function notifyNativeScreenshotPolicy(allow) {
  if (typeof window === 'undefined' || !window.ReactNativeWebView?.postMessage) {
    return;
  }
  window.ReactNativeWebView.postMessage(JSON.stringify({
    type: 'allow_screenshot',
    allowScreenshot: !!allow,
  }));
}

export function applyScreenshotPolicy(allow) {
  notifyNativeScreenshotPolicy(allow);
  if (allow) {
    destroyScreenshotGuard();
    return;
  }
  initScreenshotGuard();
}
